module.exports = __webpack_public_path__ + "static/media/dinis_Guarda.447e900b.jpg";